import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Breadcrumb } from 'antd';

export default function PageNavigation({ items }) {
  let counter = 0;
  const breadcrumbItems = items.map((item, index) => {
    counter += 1;
    const { node, link } = item;
    const BreadCrumb = <Breadcrumb.Item>{node}</Breadcrumb.Item>;
    const BreadCrumbWithLink = <NavLink to={link}>{BreadCrumb}</NavLink>;
    return (
      <span key={index}>
        {(link !== undefined) ? BreadCrumbWithLink : BreadCrumb }
        { (counter !== items.length+1 && link === undefined) ? <Breadcrumb.Separator /> : null }
      </span>
    );
  });
  return (
    <Breadcrumb separator="">
      { breadcrumbItems }
    </Breadcrumb>
  );
}

PageNavigation.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    node: PropTypes.any,
    link: PropTypes.string,
  })),
};

PageNavigation.defaultProps = {
  items: [],
};
